import ConsentPendingIcon from "../../assets/images/ConsentPendingIcon";
import EKycVerifiedIcon from "../../assets/images/EKycVerifiedIcon";
import { UserValidationStatus } from "../../constants/constants";
import { EKYCStatus } from "../../store/slices/userDetailslice";

export const getUserValidationStatus = (
  consentStatus: any,
  ekycStatus: EKYCStatus,
  isAndroid: boolean = false
) => {
  console.log("object", consentStatus, ekycStatus, isAndroid);
  if (consentStatus === false)
    return {
      status: UserValidationStatus.consentPending,
      icon: (
        <ConsentPendingIcon
          height={isAndroid ? "12px" : "24px"}
          width={isAndroid ? "12px" : "24px"}
        />
      ),
      backGroundColor: "bg-consentLinkBackgroundColor",
      textColor: "text-redColor",
    };
  else if (
    ekycStatus?.pan === true ||
    ekycStatus?.drivingLicense === true ||
    ekycStatus?.bank === true
  )
    return {
      status: UserValidationStatus.ekycVerified,
      icon: (
        <EKycVerifiedIcon
          height={isAndroid ? "12px" : "24px"}
          width={isAndroid ? "12px" : "24px"}
        />
      ),
      backGroundColor: "bg-eKycVerifiedColor",
      textColor: "text-black",
    };
  else
    return {
      status: UserValidationStatus.ekycPending,
      icon: (
        <ConsentPendingIcon
          height={isAndroid ? "12px" : "24px"}
          width={isAndroid ? "12px" : "24px"}
        />
      ),
      backGroundColor: "bg-consentLinkBackgroundColor",
      textColor: "text-redColor",
    };
};
